import { Instant } from 'temporal-luxon';
import { normalizeCustomDataRows } from 'libs.consent.common';
/** Newest this many entries are shown on the Configuration tab; older ones stay stored. */
const CONFIGURATION_DATA_AUDIT_VISIBLE = 10;
/** Same author within this window is one amendment, not one entry per autosave debounce. */
const COALESCE_WINDOW_MS = 5 * 60 * 1000;
export const configurationDataAuditAuthor = (user) => user?.displayName?.trim() || user?.email?.trim() || user?.uid?.trim() || 'Unknown';
export const elementCustomDataFingerprint = (elements) => JSON.stringify(elements
    .map((element) => ({
    id: element.id,
    rows: Array.isArray(element.config.ec__custom_data)
        ? normalizeCustomDataRows(element.config.ec__custom_data)
        : [],
}))
    .filter(({ rows }) => rows.length > 0)
    .sort((a, b) => a.id.localeCompare(b.id)));
export const withConfigurationDataAuditEntry = (previousFingerprint, nextFingerprint, trail, author, at) => {
    if (previousFingerprint === undefined || previousFingerprint === nextFingerprint) {
        return trail;
    }
    const last = trail[trail.length - 1];
    if (last?.author === author) {
        const deltaMs = Math.abs(Instant.from(at).epochMilliseconds - Instant.from(last.at).epochMilliseconds);
        if (deltaMs <= COALESCE_WINDOW_MS) {
            return trail;
        }
    }
    return [...trail, { at, author }];
};
export const visibleConfigurationDataAudit = (trail) => ({
    entries: trail
        .slice(-CONFIGURATION_DATA_AUDIT_VISIBLE)
        .map((entry, offset) => ({
        ...entry,
        listKey: `${entry.at}-${entry.author}-${offset}`,
    }))
        .reverse(),
    olderCount: Math.max(0, trail.length - CONFIGURATION_DATA_AUDIT_VISIBLE),
});
